import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8dda142"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "contents1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "com_w_title1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "com_inner1 clearfix" }, "《奨励制度/表彰制度 実績進捗表》")
], -1))
const _hoisted_3 = { class: "com_inner1 clearfix" }
const _hoisted_4 = { class: "parent" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-side" }, " ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "com_page_ancor1" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#anchor1" }, [
      /*#__PURE__*/_createElementVNode("span", null, "奨励制度")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#anchor2" }, [
      /*#__PURE__*/_createElementVNode("span", null, "表彰制度")
    ])
  ])
], -1))
const _hoisted_7 = { class: "right-side" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text__item" }, "実績進捗表のダウンロードはこちら"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text__item",
    "aria-hidden": "true"
  }, " 実績進捗表のダウンロードはこちら ")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "com_data_title1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "anchor1",
    id: "anchor1"
  }),
  /*#__PURE__*/_createTextVNode("奨励制度 ")
], -1))
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "select1" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "com_f_sw_radio1" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "targetYearPrev" }, "前年", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "targetYearCurrent" }, "今年", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_fs14" }, "参考：当月時点奨励制度進捗状況", -1))
const _hoisted_21 = { class: "row-height1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "累計増加額実績", -1))
const _hoisted_23 = { class: "row-height1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "奨励金進捗状況", -1))
const _hoisted_25 = { class: "com_inc_tabel1 a" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "all1 col-shorei-total" }, "上期合計", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "all1 col-total-s" }, "下期合計", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "all1 col-total-s" }, "当月累計", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "all1 col-total-s" }, "年間合計", -1))
const _hoisted_31 = ["rowspan"]
const _hoisted_32 = { class: "all1" }
const _hoisted_33 = { class: "all1" }
const _hoisted_34 = { class: "all1" }
const _hoisted_35 = { class: "all1" }
const _hoisted_36 = {
  key: 0,
  class: "com_fs12 com_mgt10"
}
const _hoisted_37 = { class: "com_inc_cnt1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "上半期", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "下半期", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "com_mgt35 separator-top-1px" }, null, -1))
const _hoisted_41 = { class: "com_data_title1 com_mgt35" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title1" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "anchor1",
    id: "anchor2"
  }),
  /*#__PURE__*/_createTextVNode("表彰制度 ")
], -1))
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "com_fs14" }, "参考：当月時点表彰制度進捗状況", -1))
const _hoisted_45 = { class: "row-height1" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "売上累計増加額実績", -1))
const _hoisted_47 = {
  key: 0,
  class: "row-height1"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "累計ユニーク稼働ID実績", -1))
const _hoisted_49 = { class: "com_inc_tabel1 b" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "all1 col-total-h" }, "当月累計", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "all1 col-total-h" }, "年間合計", -1))
const _hoisted_53 = ["rowspan"]
const _hoisted_54 = { class: "all1" }
const _hoisted_55 = { class: "all1" }
const _hoisted_56 = {
  key: 1,
  class: "com_fs12 com_mgt10"
}
const _hoisted_57 = { class: "com_inc_cnt2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "売上累計増加金額", -1))
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "累計ユニーク稼働ID増加数", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_ShoreiChartComponent = _resolveComponent("ShoreiChartComponent")!
  const _component_HyoshoChartComponent = _resolveComponent("HyoshoChartComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (!_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_ctx.jissekiFileName)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      class: "com_s_button1",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)), ["prevent"]))
                    }, _hoisted_9))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("a", {
                  href: _ctx.shoreiLinkUrl,
                  target: "_blank",
                  class: "link1 com_link2 g"
                }, " 奨励制度について", 8, _hoisted_12)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      class: "com_f_select1",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetSystem) = $event)),
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeTargetSystem && _ctx.onChangeTargetSystem(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetSystemList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_14))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.targetSystem]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "targetYearPrev",
                        value: _ctx.IncentiveConstants.TARGET_YEAR_PREV,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.targetYear) = $event)),
                        onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChangeTargetYear && _ctx.onChangeTargetYear(...args)))
                      }, null, 40, _hoisted_16), [
                        [_vModelRadio, _ctx.targetYear]
                      ]),
                      _hoisted_17,
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "targetYearCurrent",
                        value: _ctx.IncentiveConstants.TARGET_YEAR_CURRENT,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.targetYear) = $event)),
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onChangeTargetYear && _ctx.onChangeTargetYear(...args)))
                      }, null, 40, _hoisted_18), [
                        [_vModelRadio, _ctx.targetYear]
                      ]),
                      _hoisted_19
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass({ 'hidden-element': !_ctx.isTargetYearCurrent })
              }, [
                _hoisted_20,
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("td", null, [
                        (_ctx.isGetJisseki && _ctx.shoreiRuikeiZokagaku)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({
                      negative: _ctx.isNegativeComputed(_ctx.shoreiRuikeiZokagaku),
                    })
                            }, _toDisplayString(_ctx.formatCurrency(_ctx.shoreiRuikeiZokagaku)), 3))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tr", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("td", null, [
                        (_ctx.isGetJisseki && _ctx.shoreiShinchokuJokyo)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({
                      negative: _ctx.isNegativeComputed(_ctx.shoreiShinchokuJokyo),
                    })
                            }, _toDisplayString(_ctx.formatCurrency(_ctx.shoreiShinchokuJokyo)), 3))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("table", _hoisted_25, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '1' }, "col-month-s"])
                  }, " 1月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '2' }, "col-month-s"])
                  }, " 2月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '3' }, "col-month-s"])
                  }, " 3月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '4' }, "col-month-s"])
                  }, " 4月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '5' }, "col-month-s"])
                  }, " 5月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '6' }, "col-month-s"])
                  }, " 6月 ", 2),
                  _hoisted_27,
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '7' }, "col-month-s"])
                  }, " 7月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '8' }, "col-month-s"])
                  }, " 8月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '9' }, "col-month-s"])
                  }, " 9月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '10' }, "col-month-s"])
                  }, " 10月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '11' }, "col-month-s"])
                  }, " 11月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.shoreiList[0]?.hokokuMonth == '12' }, "col-month-s"])
                  }, " 12月 ", 2),
                  _hoisted_28,
                  _hoisted_29,
                  _hoisted_30
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getShoreiGroupedData, (group, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, rowIndex) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: rowIndex,
                        class: _normalizeClass({
                bg1: _ctx.isChangeBgColorShorei(item),
                bdb1: rowIndex === group.length - 1,
              })
                      }, [
                        (rowIndex == 0)
                          ? (_openBlock(), _createElementBlock("th", {
                              key: 0,
                              rowspan: group.length,
                              class: "vt1"
                            }, _toDisplayString(item.groupTitle), 9, _hoisted_31))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", null, _toDisplayString(item.rowTitle), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '1' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month01) })
                          }, _toDisplayString(item.month01), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '2' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month02) })
                          }, _toDisplayString(item.month02), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '3' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month03) })
                          }, _toDisplayString(item.month03), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '4' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month04) })
                          }, _toDisplayString(item.month04), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '5' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month05) })
                          }, _toDisplayString(item.month05), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '6' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month06) })
                          }, _toDisplayString(item.month06), 3)
                        ], 2),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.kamikiTotal) })
                          }, _toDisplayString(item.kamikiTotal), 3)
                        ]),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '7' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month07) })
                          }, _toDisplayString(item.month07), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '8' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month08) })
                          }, _toDisplayString(item.month08), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '9' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month09) })
                          }, _toDisplayString(item.month09), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '10' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month10) })
                          }, _toDisplayString(item.month10), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '11' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month11) })
                          }, _toDisplayString(item.month11), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.shoreiList[0]?.hokokuMonth == '12' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month12) })
                          }, _toDisplayString(item.month12), 3)
                        ], 2),
                        _createElementVNode("td", _hoisted_33, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.shimokiTotal) })
                          }, _toDisplayString(item.shimokiTotal), 3)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.togetsuRuikei) })
                          }, _toDisplayString(item.togetsuRuikei), 3)
                        ]),
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.yearTotal) })
                          }, _toDisplayString(item.yearTotal), 3)
                        ])
                      ], 2))
                    }), 128))
                  ], 64))
                }), 128))
              ])
            ]),
            (_ctx.isShoreiDispUniqueKado)
              ? (_openBlock(), _createElementBlock("p", _hoisted_36, " ※累計ユニーク…集計期間中にご購入頂いたお客様数 "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", null, [
                _hoisted_38,
                (_ctx.isGetJisseki)
                  ? (_openBlock(), _createBlock(_component_ShoreiChartComponent, {
                      key: 0,
                      labels: ['1月', '2月', '3月', '4月', '5月', '6月'],
                      tonenChartData: _ctx.shoreiKamikiUriageChart.tonenDataList,
                      zennenChartData: _ctx.shoreiKamikiUriageChart.zennenDataList,
                      mokuhyoChartData: _ctx.shoreiKamikiUriageChart.mokuhyoDataList,
                      ruikeiChartData: _ctx.shoreiKamikiUriageChart.ruikeiDataList
                    }, null, 8, ["tonenChartData", "zennenChartData", "mokuhyoChartData", "ruikeiChartData"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _hoisted_39,
                (_ctx.isGetJisseki)
                  ? (_openBlock(), _createBlock(_component_ShoreiChartComponent, {
                      key: 0,
                      labels: ['7月', '8月', '9月', '10月', '11月', '12月'],
                      tonenChartData: _ctx.shoreiShimokiUriageChart.tonenDataList,
                      zennenChartData: _ctx.shoreiShimokiUriageChart.zennenDataList,
                      mokuhyoChartData: _ctx.shoreiShimokiUriageChart.mokuhyoDataList,
                      ruikeiChartData: _ctx.shoreiShimokiUriageChart.ruikeiDataList
                    }, null, 8, ["tonenChartData", "zennenChartData", "mokuhyoChartData", "ruikeiChartData"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", null, [
                _hoisted_42,
                _createElementVNode("a", {
                  href: _ctx.hyoshoLinkUrl,
                  target: "_blank",
                  class: "link1 com_link2 g"
                }, " 表彰制度について", 8, _hoisted_43)
              ]),
              _createElementVNode("div", null, [
                _hoisted_44,
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", _hoisted_45, [
                      _hoisted_46,
                      _createElementVNode("td", null, [
                        (_ctx.isGetJisseki && _ctx.hyoshoRuikeiZokagaku)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass({
                      negative: _ctx.isNegativeComputed(_ctx.hyoshoRuikeiZokagaku),
                    })
                            }, _toDisplayString(_ctx.formatCurrency(_ctx.hyoshoRuikeiZokagaku)), 3))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.isHyoshoDispUniqueKado)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_47, [
                          _hoisted_48,
                          _createElementVNode("td", null, [
                            (_ctx.isGetJisseki && _ctx.hyoshoRuikeiKadoId)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: _normalizeClass({
                      negative: _ctx.isNegativeComputed(_ctx.hyoshoRuikeiKadoId),
                    })
                                }, _toDisplayString(_ctx.hyoshoRuikeiKadoId + "ID"), 3))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_49, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _hoisted_50,
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '8' }, "col-month-h"])
                  }, " 8月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '9' }, "col-month-h"])
                  }, " 9月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '10' }, "col-month-h"])
                  }, " 10月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '11' }, "col-month-h"])
                  }, " 11月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '12' }, "col-month-h"])
                  }, " 12月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '1' }, "col-month-h"])
                  }, " 1月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '2' }, "col-month-h"])
                  }, " 2月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '3' }, "col-month-h"])
                  }, " 3月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '4' }, "col-month-h"])
                  }, " 4月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '5' }, "col-month-h"])
                  }, " 5月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '6' }, "col-month-h"])
                  }, " 6月 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([{ this1: _ctx.hyoshoList[0]?.hokokuMonth == '7' }, "col-month-h"])
                  }, " 7月 ", 2),
                  _hoisted_51,
                  _hoisted_52
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHyoshoGroupedData, (group, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, rowIndex) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: rowIndex,
                        class: _normalizeClass({
                bg1: _ctx.isChangeBgColorHyosho(item),
                bdb1: rowIndex === group.length - 1,
              })
                      }, [
                        (rowIndex == 0)
                          ? (_openBlock(), _createElementBlock("th", {
                              key: 0,
                              rowspan: group.length,
                              class: "vt1"
                            }, _toDisplayString(item.groupTitle), 9, _hoisted_53))
                          : _createCommentVNode("", true),
                        _createElementVNode("th", null, _toDisplayString(item.rowTitle), 1),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '8' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month01) })
                          }, _toDisplayString(item.month01), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '9' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month02) })
                          }, _toDisplayString(item.month02), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '10' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month03) })
                          }, _toDisplayString(item.month03), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '11' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month04) })
                          }, _toDisplayString(item.month04), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '12' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month05) })
                          }, _toDisplayString(item.month05), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '1' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month06) })
                          }, _toDisplayString(item.month06), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '2' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month07) })
                          }, _toDisplayString(item.month07), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '3' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month08) })
                          }, _toDisplayString(item.month08), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '4' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month09) })
                          }, _toDisplayString(item.month09), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '5' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month10) })
                          }, _toDisplayString(item.month10), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '6' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month11) })
                          }, _toDisplayString(item.month11), 3)
                        ], 2),
                        _createElementVNode("td", {
                          class: _normalizeClass({ this1: _ctx.hyoshoList[0]?.hokokuMonth == '7' })
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.month12) })
                          }, _toDisplayString(item.month12), 3)
                        ], 2),
                        _createElementVNode("td", _hoisted_54, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.togetsuRuikei) })
                          }, _toDisplayString(item.togetsuRuikei), 3)
                        ]),
                        _createElementVNode("td", _hoisted_55, [
                          _createElementVNode("span", {
                            class: _normalizeClass({ minus1: _ctx.isNegative(item.yearTotal) })
                          }, _toDisplayString(item.yearTotal), 3)
                        ])
                      ], 2))
                    }), 128))
                  ], 64))
                }), 128))
              ])
            ]),
            (_ctx.isHyoshoDispUniqueKado)
              ? (_openBlock(), _createElementBlock("p", _hoisted_56, " ※累計ユニーク…集計期間中にご購入頂いたお客様数 "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("div", null, [
                _hoisted_58,
                (_ctx.isGetJisseki)
                  ? (_openBlock(), _createBlock(_component_HyoshoChartComponent, {
                      key: 0,
                      tonenChartData: _ctx.hyoshoUriageChart.tonenDataList,
                      zennenChartData: _ctx.hyoshoUriageChart.zennenDataList,
                      ruikeiChartData: _ctx.hyoshoUriageChart.ruikeiDataList
                    }, null, 8, ["tonenChartData", "zennenChartData", "ruikeiChartData"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isHyoshoDispUniqueKado)
                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                    _hoisted_60,
                    (_ctx.isGetJisseki)
                      ? (_openBlock(), _createBlock(_component_HyoshoChartComponent, {
                          key: 0,
                          tonenChartData: _ctx.hyoshoKadoIdChart.tonenDataList,
                          zennenChartData: _ctx.hyoshoKadoIdChart.zennenDataList,
                          ruikeiChartData: _ctx.hyoshoKadoIdChart.ruikeiDataList
                        }, null, 8, ["tonenChartData", "zennenChartData", "ruikeiChartData"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FooterComponent),
    _createVNode(_component_BackToTop)
  ], 64))
}